import { StatusDotIcon } from '@dealstack/frontend/app/pages/Project/MIP/Messages/components/StatusDotIcon/StatusDotIcon';
import { Flex, Skeleton, Text } from '@mantine/core';

interface Props {
	text: string;
	isLoading: boolean;
}

export const SessionDetailsListItem = ({ text, isLoading }: Props) => {
	return (
		<Flex align="center" gap="0.5rem">
			<StatusDotIcon color="black" />
			{isLoading ? <Skeleton height={20} /> : <Text>{text}</Text>}
		</Flex>
	);
};
